module.exports = "<shop-crud service=\"shops.service\" translations=\"shops.translations\" fields=\"shops.fields\"></shop-crud>"


//////////////////
// WEBPACK FOOTER
// ./client/app/manager/shops/shops.pug
// module id = 229
// module chunks = 0